<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>每日作业</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="5">
          <Col span="5">
            <Form-item label="上课时间">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder=""
                               v-model="queryParam.date"/>
            </Form-item>
          </Col>
          <Col span="4">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="学导" >
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyConsultantId"/>
            </Form-item>
          </Col>
          <Col span="3">
            <Form-item label="状态">
              <Select v-model.number="queryParam.status" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.reviewClockRecordStatus"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <Row :gutter="12">
          <Col span="4">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索
            </Button>
<!--            <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="exportData" >导出
            </Button>-->
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="batchCheck" >批量批改
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookMaterialLessons/dailyStudy"
      :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
    <Modal v-model="videoVisible" title="闯关视频" width="800" footer-hide @on-visible-change="onVideoVisibleChange">
      <FilePreview v-if="videoUrl" :file-url="videoUrl" type="video"></FilePreview>
    </Modal>
  </div>

</template>
<script>
  import FilePreview from '@/components/common/FilePreview'
  export default {
    components: { FilePreview },
    data () {
      return {
        searchLoading: false,
        exportLoading: false,
        passLoading: false,
        reload: 0,
        uid: null,
        selectionIds: [],
        videoVisible: false,
        videoUrl: '',
        queryParam: {
          uid: null,
          status: null,
          studyConsultantId: null,
          date: new Date(),
        },
        title: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '学生',
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickname)
            }
          },
          {
            title: '学导',
            align: 'center',
            width: 180,
            render: (h, params) => {
              let row = params.row
              if (row.studyConsultantId === 0) {
                return h('span', '未分配')
              }
              return h('span', row.studyConsultantId + '-' + row.studyAdviserName)
            }
          },
          {
            title: '课程名称',
            align: 'center',
            width: 150,
            key: 'lessonTitle'
          },
          {
            title: '上课时间',
            align: 'center',
            width: 170,
            key: 'lessonTime'
          },
          {
            title: '单词跟读',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.readWord.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.readWord.exist && row.readWord.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.readWord.exist && !row.readWord.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '句子跟读',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.readSentence.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.readSentence.exist && row.readSentence.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.readSentence.exist && !row.readSentence.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '听音选图',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.choiceWord.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.choiceWord.exist && row.choiceWord.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.choiceWord.exist && !row.choiceWord.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '情景理解',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.choiceSentence.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.choiceSentence.exist && row.choiceSentence.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.choiceSentence.exist && !row.choiceSentence.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '课后习题',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.lessonQuestions.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.lessonQuestions.exist && row.lessonQuestions.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.lessonQuestions.exist && !row.lessonQuestions.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '内容闯关',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = ''
              let color = ''
              if (!row.recordVideo.exist) {
                text = '没有题目'
                color = 'blue'
              } else if (row.recordVideo.exist && row.recordVideo.completed) {
                text = '已完成'
                color = 'green'
              } else if (row.recordVideo.exist && !row.recordVideo.completed) {
                text = '未完成'
                color = 'red'
              }
              return h('span', { style: { color: color } }, text)
            }
          },
          {
            title: '闯关视频',
            align: 'center',
            width: 80,
            render: (h, params) => {
              let row = params.row
              if (row.recordVideo.exist && row.recordVideo.completed) {
                let videoUrls = (row.recordVideo.videoUrl || []).filter(function (url) {
                  return !!url
                })
                let index = 1
                let links = videoUrls.map(url => {
                  return h('a', {
                    on: {click: () => this.openVideoModal(url)},
                    style: {display: 'block', margin: '5px 0'}
                  }, '查看' + index++)
                })
                if (links.length === 0) {
                  return h('span', '')
                }
                return h('div', links)
              }
            }
          },
          {
            title: '批改时间',
            align: 'center',
            width: 170,
            key: 'reviewTime'
          },
          {
            title: '批改人',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              if (row.adminId === undefined){
                return h('span', '未批改')
              }
              return h('span', row.adminId + '-' + row.adminName)
            }
          },

          {
            title: '操作',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let text = row.status ? '撤销批改' : '批改'
              let color = row.status ? 'red' : ''
              return h('a', {on: {click: () => this.check(row.bookLessonOpenedId, !row.status, text)}, style: { color: color }}, text)
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      openVideoModal (val) {
        if (!val) {
          return
        }
        this.videoUrl = val
        this.videoVisible = true
      },
      onVideoVisibleChange (visible) {
        if (!visible) {
          this.videoUrl = ''
        }
      },
      search () {
        this.selectionIds = []
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      check (id, status, text) {
        let self = this
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">' + text + '</span>?',
          width: 300,
          okText: '确认',
          onOk: () => {
            self.$http.post('/bookMaterialLessons/check', {ids: [id], status: status}).then(function (res) {
              if (res) {
                self.search()
              }
            })
          }
        })
      },
      selectionChange (selection) {
        this.selectionIds = selection
      },
      batchCheck () {
        if (this.selectionIds.length <= 0) {
          this.$Message.warning('请选择需批改的记录！')
          return
        }
        let self = this
        let idList = self.selectionIds.map(function (element) {
          return element.bookLessonOpenedId
        })
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">批量完成批改</span>?',
          width: 300,
          okText: '确认',
          onOk: () => {
            self.$http.post('/bookMaterialLessons/check', {ids: idList, status: 1}).then(function (res) {
              if (res) {
                self.search()
              }
            })
          }
        })
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/study_record/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '打卡闯关列表.xlsx'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// DailyStudy.vue?edd7a9ca